import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamationCircle } from 'react-icons/all';
import { useDispatch, useSelector } from 'react-redux';
import { changePassword } from '../../../../actions/accountActions';
import { closeAllModals } from '../../../../actions/modalActions';
import { ReactComponent as Close } from '../../../../icons/close-button.svg';
import IAccountReducer from '../../../../interfaces/reducers/accountReducer';
import { IStore } from '../../../../reducers';
import Button from '../../../base/button/button';
import FormikFieldWrapper from '../../../base/forms/formikFieldWrapper';
import { StyledFormikField } from '../../../base/forms/input';
import { A } from '../../../base/typography';
import * as StyledModals from '../myShipmentsModals.styles';
import { changePasswordInitialValues, changePasswordSchema } from './changePassword.schema';

interface Props {}

const ChangePassword: FC<Props> = () => {
	const { t } = useTranslation('myShipments');
	const dispatch = useDispatch<any>();
	const accountReducer: IAccountReducer = useSelector<IStore, IAccountReducer>(store => store.accountReducer);
	const { modalSubmitPending, modalSubmitError, modalSubmitErrorDetails } = accountReducer;

	const closeModal = () => {
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	return (
		<StyledModals.Wrapper>
			<StyledModals.Heading>
				<div>{t('page-settings.changePassword')}</div>
				<A onClick={closeModal}>
					<Close />
				</A>
			</StyledModals.Heading>

			{modalSubmitError && (
				<StyledModals.ErrorMessage>
					<FaExclamationCircle />
					<div>{modalSubmitErrorDetails !== '' ? modalSubmitErrorDetails : t('genericError')}</div>
				</StyledModals.ErrorMessage>
			)}

			<Formik
				initialValues={changePasswordInitialValues}
				validationSchema={changePasswordSchema}
				onSubmit={values => {
					dispatch(changePassword(values.passwordOld, values.passwordNew, values.passwordConfirm));
				}}>
				<Form>
					<FormikFieldWrapper
						label={t('page-settings.oldPassword')}
						name="passwordOld"
						languageComponent="myShipments"
						smallLabel>
						<StyledFormikField
							type="password"
							id="passwordOld"
							name="passwordOld"
							placeholder={t('page-settings.oldPassword')}
						/>
					</FormikFieldWrapper>

					<FormikFieldWrapper
						label={t('page-settings.newPassword')}
						name="passwordNew"
						languageComponent="myShipments"
						smallLabel>
						<StyledFormikField
							type="password"
							id="passwordNew"
							name="passwordNew"
							placeholder={t('page-settings.newPassword')}
						/>
					</FormikFieldWrapper>

					<FormikFieldWrapper
						label={t('page-settings.repeatNewPassword')}
						name="passwordConfirm"
						languageComponent="myShipments"
						smallLabel>
						<StyledFormikField
							type="password"
							id="passwordConfirm"
							name="passwordConfirm"
							placeholder={t('page-settings.repeatNewPassword')}
						/>
					</FormikFieldWrapper>

					<Button primary type="submit" isLoading={modalSubmitPending}>
						{t('save')}
					</Button>
				</Form>
			</Formik>
		</StyledModals.Wrapper>
	);
};

export default ChangePassword;
